import { View } from 'foundations-components/transitional/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SidebarSection from './SidebarSection';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import { getThemeImageUrl, getThemeName } from '../../selectors/themeSelectors';
import { isFulfilled } from '../../utils/requestStatus';
import { getDependentPagesRequestStatus, getDependentTemplatesRequestStatus, getGroupedDependentAssetOptionsCount } from '../../selectors/themeDependentAssetsSelectors';
import { useSelector } from 'react-redux';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useState } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
//@ts-ignore not typed yet
import { noThemeImage } from 'ContentComponents/imgAssets';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Link } from 'foundations-components/transitional/components/Link';
import { NextIcon } from 'foundations-assets/icons/components/NextIcon';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { setHasDismissedShepherdTooltip, getHasDismissedShepherdTooltip } from '../../utils/betaUtils';
import { isPortalMode as isPortalModeSelector } from '../../selectors/portalSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const i18nKey = key => `theme-previewer.themeSettings.universal.${key}`;
const ThemeTile = ({
  dependentsCount,
  isAssetsReady,
  toggleDependentsPanel
}) => {
  const imageUrl = useSelector(getThemeImageUrl);
  const themeName = useSelector(getThemeName);
  const [isShepherdTooltipOpen, setIsShepherdTooltipOpen] = useState(!getHasDismissedShepherdTooltip());
  const handleCloseShepherdTooltip = () => {
    setIsShepherdTooltipOpen(false);
    setHasDismissedShepherdTooltip();
  };
  const shepherdTooltip = /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsxs(View, {
      paddingBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('shepherdTooltip.title')
        })
      }), /*#__PURE__*/_jsx(CloseButton, {
        onClick: handleCloseShepherdTooltip,
        size: "medium",
        color: "icon-core-subtle"
      })]
    }), /*#__PURE__*/_jsx(View, {
      paddingInline: "200",
      paddingBlockEnd: "500",
      children: /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('shepherdTooltip.body')
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleCloseShepherdTooltip,
        size: "sm",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('shepherdTooltip.buttonText')
        })
      })
    })]
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    title: shepherdTooltip,
    open: isShepherdTooltipOpen,
    minInlineSize: "360px",
    placement: "right",
    use: "longform",
    marginInlineStart: "-600",
    children: /*#__PURE__*/_jsx(View, {
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-default",
      borderBlockEndWidth: "100",
      paddingBlock: "600",
      paddingInlineStart: "400",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Image, {
          blockSize: "71px",
          inlineSize: "83px",
          responsive: false,
          objectFit: "cover",
          src: imageUrl || noThemeImage,
          paddingInlineEnd: "400"
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h6",
            truncate: true,
            children: themeName
          }), isAssetsReady && /*#__PURE__*/_jsx(Flex, {
            flexDirection: "column",
            paddingBlockStart: "200",
            children: /*#__PURE__*/_jsx(Text, {
              typography: "detail-100",
              children: /*#__PURE__*/_jsxs(Button, {
                use: "link",
                onClick: toggleDependentsPanel,
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  message: i18nKey('assets'),
                  options: {
                    count: dependentsCount
                  }
                }), /*#__PURE__*/_jsx(IconHolder, {
                  icon: NextIcon,
                  padding: "0"
                })]
              })
            })
          }), !isAssetsReady && /*#__PURE__*/_jsx(LoadingSpinner, {
            size: "extra-small",
            grow: true
          })]
        })]
      })
    })
  });
};
const ThemeSettingsHeader = ({
  breadcrumbsAreVisible,
  breakpointEditingAlert,
  isUniversalThemeEditing,
  onClose,
  resetButton,
  showThemeTile,
  toggleDependentsPanel,
  canAccessThemeEdit
}) => {
  const dependentsCount = useSelector(getGroupedDependentAssetOptionsCount);
  const isInPortalMode = useSelector(isPortalModeSelector);
  const dependentPagesRequestStatus = useSelector(getDependentPagesRequestStatus);
  const dependentTemplatesRequestStatus = useSelector(getDependentTemplatesRequestStatus);
  const isAssetsReady = isFulfilled(dependentPagesRequestStatus) && isFulfilled(dependentTemplatesRequestStatus);
  let helpText;
  if (!showThemeTile) {
    helpText = isAssetsReady ? /*#__PURE__*/_jsx(Text, {
      as: "small",
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: i18nKey('helpTextWithAssets_jsx'),
        elements: {
          Button
        },
        options: {
          count: dependentsCount,
          onClick: toggleDependentsPanel
        }
      })
    }) : /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "extra-small",
      grow: true
    });
  } else if (canAccessThemeEdit) {
    helpText = /*#__PURE__*/_jsx(Text, {
      as: "small",
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('helpText')
      })
    });
  }
  if (isInPortalMode) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-default",
      borderBlockEndWidth: "100",
      children: /*#__PURE__*/_jsxs(SidebarSection, {
        paddingBlockStart: "500",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsxs(Flex, {
            alignItems: "start",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h5",
              marginBlockEnd: "0",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('header')
              })
            }), !canAccessThemeEdit && /*#__PURE__*/_jsx(Tooltip, {
              title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                message: i18nKey('viewOnlyTooltip_jsx'),
                elements: {
                  Link
                },
                options: {
                  onClick: () => window.open('https://knowledge.hubspot.com/website-pages/use-themes')
                }
              }),
              children: /*#__PURE__*/_jsx(View, {
                backgroundColor: "border-core-disabled",
                padding: "100",
                borderStyle: "solid",
                borderColor: "icon-interactive-hover",
                borderWidth: "100",
                marginInlineStart: "100",
                children: /*#__PURE__*/_jsx(Text, {
                  typography: "detail-100",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: i18nKey('viewOnly')
                  })
                })
              })
            }), isUniversalThemeEditing && /*#__PURE__*/_jsx(Badge, {
              use: "beta",
              marginInline: "200",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('betaBadge')
              })
            })]
          }), /*#__PURE__*/_jsxs(Flex, {
            justifyContent: "space-between",
            alignItems: "center",
            minInlineSize: isUniversalThemeEditing ? '15%' : undefined,
            children: [resetButton, isUniversalThemeEditing && onClose && /*#__PURE__*/_jsx(CloseButton, {
              color: "icon-core-subtle",
              "data-selenium": "save-and-close-sidebar",
              onClick: onClose,
              size: "medium"
            })]
          })]
        }), breakpointEditingAlert, /*#__PURE__*/_jsx(View, {
          as: "div",
          children: helpText
        })]
      })
    }), showThemeTile && !breadcrumbsAreVisible && /*#__PURE__*/_jsx(ThemeTile, {
      dependentsCount: dependentsCount,
      isAssetsReady: isAssetsReady,
      toggleDependentsPanel: toggleDependentsPanel
    })]
  });
};
export default ThemeSettingsHeader;